import { render, staticRenderFns } from "./CompanyContactInfo.vue?vue&type=template&id=37e97ef8&"
import script from "./CompanyContactInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports